export default __webpack_public_path__ + "static/media/vertical_belonging.612736fb.jpg";